import {
    OBTENER_HISTORICO,
    HISTORICO_ERROR,
    HISTORICO_OK,
    START_LOADING,
    STOP_LOADING,
    SELECCIONAR_GRAFICO,
    FILTRO_FECHA
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case START_LOADING:
            return {
                ...state,
                loading: true
            }
        case STOP_LOADING:
            return {
                ...state,
                loading: false
            }
        case OBTENER_HISTORICO:
            return {
                ...state,
                historico: action.payload
            }
        case HISTORICO_ERROR:
            return {
                ...state,
                mensaje: action.payload
            }
        case HISTORICO_OK:
            return {
                ...state,
                mensaje: action.payload
            }
        case SELECCIONAR_GRAFICO:
            return {
                ...state,
                graficoElegido: action.payload
            }
        case FILTRO_FECHA:
            return {
                ...state,
                textoFiltroFecha: fechaFiltro(action.payload)
            }
        default:
            return state;
    }
}

const fechaFiltro = ( {fechaDesde , fechaHasta} ) => {
    if (fechaDesde && fechaHasta){
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour:'numeric', minute:'numeric' };
      let horaD= (fechaDesde.toTimeString()).slice(0,5)
      let horaH= (fechaHasta.toTimeString()).slice(0,5)
      let añoD= (fechaDesde.getFullYear())
      let añoH= (fechaHasta.getFullYear())
      let diaD= (fechaDesde.toLocaleDateString("es-ES", options)).slice(0,3)
      let diaH= (fechaHasta.toLocaleDateString("es-ES", options)).slice(0,3)
      let mesD= (fechaDesde.toLocaleDateString("es-ES", options)).split("de ")[1].slice(0,3)
      let mesH= (fechaHasta.toLocaleDateString("es-ES", options)).split("de ")[1].slice(0,3)
      let numD= (fechaDesde.toLocaleDateString("es-ES", options)).split(",")[1].split("de ")[0]
      let numH= (fechaHasta.toLocaleDateString("es-ES", options)).split(",")[1].split("de ")[0]
      return  <div style={{textAlign:"right"}}> {diaD.charAt(0).toUpperCase()+ diaD.slice(1) + "," + numD +" de " + mesD.charAt(0).toUpperCase()+mesD.slice(1) + " de "+ añoD +" "+ horaD } <br></br> {diaH.charAt(0).toUpperCase()+ diaH.slice(1) +","+ numH + " de "+ mesH.charAt(0).toUpperCase()+mesH.slice(1) + " de "+ añoH +" "+ horaH }</div>
    } 
}  